module.exports = __webpack_public_path__ + "img/santa-cristina-de-lena-veraz-alteracion.09839113.png";